import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=51535d7e&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"
import style0 from "./projects.vue?vue&type=style&index=0&id=51535d7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51535d7e",
  null
  
)

export default component.exports